import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button
} from 'reactstrap';
import { DatabaseMgmt } from '../../../../services/DatabaseService/DatabaseMgmt';

import { BreadCrumb } from '../../component/BreadCrumb';
import { RestroUserLogData } from '../../../../services/DatabaseService/RestroUserLogData';
import CustomDataTable from '../../../../Components/CustomTable/CustomTable';
import { formatDateTime } from '../../../../Components/Common/FormatDate';
import { Link } from 'react-router-dom';
// import { Triangle } from 'react-loader-spinner';



export default function RestroUserLogs() {
  const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
      width: "max-content",  
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};
  const [loading,setLoading] = useState(false)
   const [ dataList, setDataList] = useState([]);
  useEffect(()=>{
      const fetchData = async () => {
      try {
        const result = await RestroUserLogData.getAll();
        setDataList(result);
      } catch (error) {
        console.error("Failed to load data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  },[])
  
  console.log(dataList)
  const [filterText, setFilterText] = useState('');
  const [addModal, setAddModal] = useState(false);
 

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const filteredData = dataList.filter(item =>
    (item.name?.toLowerCase() || "").includes(filterText?.toLowerCase() || "") ||
    (item.database?.toLowerCase() || "").includes(filterText?.toLowerCase() || "")
);


  const columns = [
    {
      name: 'ID',
      selector: (row) => row.id,
      sortable: true,
      cell: (row) => (
              <Link to={`/restrolog/detail/${row?.apiKey}`}>
                {row.id} 
              </Link>
            ),
      width: "75px"
    },
    {
      name: 'Log In Time',
      selector: (row) => formatDateTime(row.logTime),
      sortable: true,
      width: "215px"
      
    },
    {
      name: 'Log For',
      selector: (row) => row.logFor,
      sortable: true,
      width: "175px"
    },
    {
      name: 'Detail',
      selector: (row) => row.logDetails,
      sortable: true,
      width: "545px"
    },
      {
      name: 'status',
      selector: (row) => row.status,
      width: "95px",
      sortable: true,
      cell: (row) => ( <button
      className={`btn btn-sm ${row.status === "Success" ? 'btn-success' : 'btn-danger'}`}
      onClick={() => console.log('Button clicked for', row)}
    >
      {row.status === "Success" ? "Success" : "Failed"}
    </button>)
    },
    {
     name: "Action",
      selector: (row) => (
        <div>
          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            // onClick={() => {
            //   setAddModal(true);
            //   // setSelectedCustomer(row);
            // }}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            // onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </div>
      ),
      center: true,
    },

  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Restro User Log List" pageTitle="Database" />
      </div>
      <Card className="d-none d-lg-block">
        <CardBody>
          <CustomDataTable
            responsive
            striped
            pagination
            fixedHeader
            persistTableHead
            progressPending={loading}
            customStyles={customStyles}
            progressComponent={
              <div className="my-3">
                {/* <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                /> */}
                <h5 className="mt-1">Loading...</h5>
              </div>
            }
            columns={columns}
            data={filteredData || []}
          />
        </CardBody>
      </Card>
      {loading ? (
        <div className="my-5 d-flex justify-content-center">
          <h5 className="mt-1">Loading...</h5>
        </div>
      ) : (
        <>
          {filteredData?.map((item, index) => (
            <Card
              key={item.id || index}
              className="mb-3 shadow-sm d-block d-lg-none mt-2"
            >
              <CardBody>
                <Row>
                  <Col xs={10}>
                    <h6 className="mb-2">
                      <strong>ID:</strong> {item.id}
                    </h6>
                    <h6 className="mb-2">
                      <strong>ApiKey:</strong> {item.apiKey}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Log For:</strong> {item.logFor}
                    </h6>
                    <h6 className="mb-2">
                      <strong>User:</strong> {item.restroUser}
                    </h6>
                    <h6 className="mb-2">
                      <strong>Description:</strong> {item.logDetails}
                    </h6>
                     {item.status === "Success"?(<button
            className="btn btn-success px-1 px-sm-2"
            onClick={() => setAddModal(true)}
          >
            Success
          </button>):(<button
            className="btn btn-danger px-1 px-sm-2"
            onClick={() => setAddModal(true)}
          >
            Failed
          </button>)}
                   
                  </Col>
                  <Col xs={2}>
                    <div>
                      <Dropdown
                        isOpen={item.dropdownOpen || false}
                        toggle={(e) => {
                          e.stopPropagation();
                          setDataList((prev) =>
                            prev.map((dbItem) =>
                              dbItem.id === item.id
                                ? {
                                    ...dbItem,
                                    dropdownOpen: !dbItem.dropdownOpen,
                                  }
                                : { ...dbItem, dropdownOpen: false }
                            )
                          );
                        }}
                        direction="down"
                      >
                        <DropdownToggle
                          color="primary"
                          outline
                          className="btn-sm shadow-sm rounded-circle"
                        >
                          <i className="ri-more-2-fill"></i>
                        </DropdownToggle>
                        <DropdownMenu end>
                          <DropdownItem
                            onClick={() => {
                              setAddModal(true);
                            }}
                          >
                            <i className="ri-edit-line text-warning me-2"></i>{" "}
                            Edit
                          </DropdownItem>
                          <DropdownItem>
                            <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                            Delete
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ))}
        </>
      )}
    </div>
  );
}